export const OTHER = 'other';
export const SCOPE_GROUP_TOP_LEVEL_GROUPINGS = {
  crm: 'crm',
  cms: 'cms',
  settings: 'settings',
  other: OTHER
};
export const PREFERRED_SCOPE_GROUP_GROUPINGS = [SCOPE_GROUP_TOP_LEVEL_GROUPINGS.crm, SCOPE_GROUP_TOP_LEVEL_GROUPINGS.cms];